import { useEffect } from 'react';

let activeModalLocks = 0;
let originalBodyOverflow = null;
let originalHtmlOverflow = null;

function lockBodyScroll() {
  activeModalLocks += 1;
  if (activeModalLocks === 1) {
    originalBodyOverflow = document.body.style.overflow;
    originalHtmlOverflow = document.documentElement.style.overflow;
    document.body.classList.add('modal-open');
    document.documentElement.classList.add('modal-open');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }
}

function unlockBodyScroll() {
  activeModalLocks = Math.max(0, activeModalLocks - 1);
  if (activeModalLocks === 0) {
    document.body.classList.remove('modal-open');
    document.documentElement.classList.remove('modal-open');
    document.body.style.overflow = originalBodyOverflow || '';
    document.documentElement.style.overflow = originalHtmlOverflow || '';
    originalBodyOverflow = null;
    originalHtmlOverflow = null;
  }
}

export default function useModalLock() {
  useEffect(() => {
    lockBodyScroll();
    return () => unlockBodyScroll();
  }, []);
}
